module.exports = __webpack_public_path__ + "assets/img/86f0fe96532789c89ab4b902bf86f66f.svg";